export const entityNameSelector = (state) => state.userInfo.entityName;

export const taxpayerNumberSelector = (state) => state.userInfo.taxpayerNumber;

export const isQuestAnswerableSelector = (state) =>
  state.userInfo.questCanAnswer === 'Y';

export const questNextResponseDateSelector = (state) =>
  state.userInfo.questNextResponseDate;

export const questExpirationDateSelector = (state) =>
  state.userInfo.questExpirationDate;

export const entityCodeSelector = (state) => state.userInfo.entityCode;
